export default "__VITE_ASSET__ccbHo04I__"